var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLowPriorityIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "icon",
    viewBox: "0 0 88 88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.224 39.708L48.292 1.776C45.924 -0.592 42.08 -0.592 39.712 1.776L1.78 39.708C-0.588002 42.076 -0.588002 45.92 1.78 48.288L39.712 86.22C42.08 88.588 45.924 88.588 48.292 86.22L86.224 48.288C88.592 45.92 88.592 42.08 86.224 39.708ZM44 68L28 52H40V24H48V52H60L44 68Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowPriorityIcon);
export default __webpack_public_path__ + "static/media/LowPriorityIcon.92b88266db66947705859b3c30375994.svg";
export { ForwardRef as ReactComponent };